import styled from 'styled-components';

export default styled.div`
  text-align: left;
  margin: 21px 21px 0 21px;
`;
